"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestPlugin = void 0;
const tsyringe_1 = require("tsyringe");
const PluginBase_1 = require("../core/pluginSystem/PluginBase");
const IHomePanelWidget_1 = require("../core/pluginSystem/IHomePanelWidget");
let TestPlugin = class TestPlugin extends PluginBase_1.PluginBase {
    constructor(name, friendlyName = "Test Plugin", description = "Does very testy things") {
        super();
        this.widgetSize = IHomePanelWidget_1.WidgetSize.Normal;
        this.basePlugin = this;
        this._name = name;
        this._friendlyName = friendlyName;
        this._description = description;
    }
    get panelName() {
        return this._friendlyName;
    }
    get panelId() {
        return this._name;
    }
    get pluginName() {
        return this._name;
    }
    get friendlyPluginName() {
        return this._friendlyName;
    }
    get useHomePanelWidget() {
        return true;
    }
    get widgetId() {
        return this.pluginName + "Widget";
    }
    get useNewSongForm() {
        return true;
    }
    get description() {
        return this._description;
    }
    get useMusicDetailsPanels() {
        return true;
    }
    getNewSongFormComponent() {
        return this;
    }
    getMusicDetailPanels() {
        return [this];
    }
    getEditSongFormComponent() {
        return this;
    }
    getHomePanelWidget() {
        return this;
    }
    addForm(formBuilder) {
        formBuilder.addParagraph("Please enter additional data you wish to save.");
        formBuilder.addTextInput("Additional Data", "additionalDataId", false);
    }
    addEditSongForm(formBuilder, metadata) {
        formBuilder.addParagraph("Please enter additional data you wish to save.");
        formBuilder.addTextInput("Additional Data", "additionalDataId", false, input => input.value = metadata.value["additionalData"]);
    }
    saveSong(formData, metadata) {
        let additionalData = formData["additionalDataId"];
        if (additionalData !== "") {
            metadata.value["additionalData"] = additionalData;
        }
        return true;
    }
    renderContent(content, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            content.createElement("p", p => p.textContent = metadata.value.additionalData);
        });
    }
    renderWidget(widgetContainer, pluginMetadata) {
        return __awaiter(this, void 0, void 0, function* () {
            widgetContainer.createHeading(this.friendlyPluginName);
            widgetContainer.createElement("p", p => p.textContent = pluginMetadata.value.additionalData);
        });
    }
};
TestPlugin = __decorate([
    tsyringe_1.injectable(),
    __metadata("design:paramtypes", [String, Object, Object])
], TestPlugin);
exports.TestPlugin = TestPlugin;
//# sourceMappingURL=TestPlugin.js.map